<script setup>
import { ref } from "vue";
import appApi from "@/services/api";
import LoadingSpinner from "@/components/LoadingComponent";
import { useRouter } from "vue-router";
import useUtil from "@/composables/useUtil";
const { porcentajeAValor } = useUtil();

const router = useRouter();

const loading = ref(true);
const listaTablaTIR = ref([]);

const getData = async () => {
  try {
    const response = await appApi().get("tablaTIR");
    listaTablaTIR.value = response.data;
    loading.value = false;
  } catch (error) {
    console.error(error);
  }
};

getData();
</script>

<template>
  <LoadingSpinner v-if="loading" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12">
                <h6>
                  <b>Tabla TIR</b>
                </h6>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="table-responsive">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Dato
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Plazo
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Etiqueta
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Anticipo
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Tasa
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Comisión
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Última renta
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="el in listaTablaTIR" :key="el.id">
                      <td class="align-middle">
                        <p class="text-xs font-weight-bold mb-0">
                          Tipo: {{ el.tipo }}
                        </p>
                        <p class="text-xs text-secondary mb-0">
                          Moneda: {{ el.moneda }}
                        </p>
                        <p class="text-xs text-secondary mb-0">
                          Rango: {{ el.rango }}
                        </p>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{
                          el.plazo
                        }}</span>
                      </td>
                      <td class="align-middle">
                        <span class="text-secondary text-xs font-weight-bold">{{
                          el.etiqueta
                        }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold"
                          >{{ porcentajeAValor(el.anticipo) }}%</span
                        >
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold"
                          >{{ porcentajeAValor(el.tasa) }}%</span
                        >
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold"
                          >{{ porcentajeAValor(el.comision) }}%</span
                        >
                      </td>
                      <td class="align-middle text-center">
                        <span class="text-secondary text-xs font-weight-bold">{{
                          el.ultima_renta
                        }}</span>
                      </td>
                      <td class="align-middle">
                        <button
                          class="text-secondary font-weight-bold text-xs btn-xs mb-0 btn btn-link p-0"
                          @click="
                            router.push({
                              name: 'tabla-tir-edit',
                              params: {
                                etiqueta: el.etiqueta,
                              },
                            })
                          "
                        >
                          <i class="ri-pencil-line me-1"></i>Modificar
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
